import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'

import '@loyal_template/password.css'

const FieldPassword = props => {
  return (
    <div className='address-form col-12 col-sm-6 mt-1 px-2'>
      <Input
        id='oldPassword'
        name='oldPassword'
        label='Senha atual'
        className='col-12 col-md-12 mb-2'
        disable='true'
        type='password'
        onChange={props.handleInputValue}
        value={props.oldPassword}
        required
        data-error='Digite sua senha atual'
        valid={props.oldPasswordIsValid}
        onBlur={props.validateOldPassword}
      />

      <Input
        id='newPassword'
        name='newPassword'
        label='Nova Senha'
        className='col-12 col-md-12 form-field mb-2'
        disable='true'
        type='password'
        onChange={props.handleInputValue}
        value={props.newPassword}
        required
        data-error='Digite sua nova senha'
        valid={props.newPasswordIsValid}
        onBlur={() => props.validateNewPassword()}
      />

      <Input
        id='confirmPassword'
        name='confirmPassword'
        label='Confirma senha'
        className='col-12 col-md-12 form-field mb-2'
        disable='true'
        type='password'
        onChange={props.handleInputValue}
        value={props.confirmPassword}
        required
        data-error='As senhas digitadas não conferem'
        valid={props.confirmPasswordIsValid}
        onBlur={props.validateConfirmPassword}
      />

      <div className='col-12 col-md-12 col-xs-3'>
        <Button
          id='Salvar'
          name='Salvar'
          text='Salvar'
          className='btn-featured btn radius btn-sm'
          onClick={props.handleSubmit}
          disabled={!props.isFormValid() || (props.isFormValid() && props.isChanged)}
        />
      </div>
    </div>
  )
}

FieldPassword.propTypes = {
  oldPassword: PropTypes.string.isRequired,
  newPassword: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  oldPasswordIsValid: PropTypes.bool,
  newPasswordIsValid: PropTypes.bool,
  confirmPasswordIsValid: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleInputValue: PropTypes.func.isRequired,
  validateConfirmPassword: PropTypes.func.isRequired,
  validateOldPassword: PropTypes.func.isRequired,
  validateNewPassword: PropTypes.func.isRequired,
  isFormValid: PropTypes.func.isRequired,
  isChanged: PropTypes.bool
}

export default FieldPassword



// WEBPACK FOOTER //
// ./src/Participant/ChangePassword/FieldPassword/FieldPassword.js